// The status code of a dependency has two names. The Application Insights JS SDK hands its
// telemetry initializers an IDependencyTelemetry, where the field is called responseCode; only
// the RemoteDependencyData that is serialised afterwards — and everything you see back in the
// portal — calls it resultCode. Reading the wrong one yields undefined without any error, which
// left both filters below silently dead in production: expected Graph failures kept counting as
// failures and canceled requests kept being reported. Read whichever one the envelope carries.
export interface DependencyStatusCarrier {
    responseCode?: string | number
    resultCode?: string | number
}

export function dependencyStatus(baseData?: DependencyStatusCarrier): string {
    return String(baseData?.responseCode ?? baseData?.resultCode ?? '')
}
